import ContactItem from "./ContactItem";
import { usePeopleContact } from "../people/apiPeople";
import ListShort from "components/ui/atoms/ListShort";

const ContactWidget = ({ peopleId }) => {
  const { data: contacts, status } = usePeopleContact(peopleId);

  return (
    <ListShort
      title="Contact"
      resource={{ results: contacts }}
      resourceStatus={status}
      ListItemComponent={ContactItem}
      emptyMessage="No Contact"
    />
  );
};

export default ContactWidget;
